import React from 'react';

// Components
import ToolbarTool from '../../ToolbarTool';
import Icon from '../../../../../components/icons/Icon';
import { useActiveTableCallback, useActiveTableSelector } from '../../../../../element/table/store/hotTableStoreHooks';

// Utils
import { getNewTransactionId } from '../../../../../utils/undoRedo/undoRedoTransactionManager';
import { isSelectingMultipleSelections } from '../../../../../element/table/utils/tableCellSelectionUtils';
import { addHotTableColsRight } from '../../../../../element/table/utils/hotInstanceUtils/hotTableGridOperationsUtils';

// Selectors
import { selectActiveTableCellSelection } from '../../../../../element/table/store/selectors/activeHotTableSelectors';

const AddColumnTool: React.FC = (props) => {
    const currentCellSelections = useActiveTableSelector(selectActiveTableCellSelection);

    const onClick = useActiveTableCallback(
        (activeTable) => addHotTableColsRight(activeTable, undefined, getNewTransactionId()),
        [],
    );

    return (
        <div className="AddColumnTool">
            <ToolbarTool
                {...props}
                onClick={onClick}
                isActive={false}
                disabled={isSelectingMultipleSelections(currentCellSelections)}
                tooltipEnabled={true}
                shortcut={['alt', '→']}
            >
                <Icon name="toolbar-add-column" />
            </ToolbarTool>
        </div>
    );
};

export default AddColumnTool;
